import { MedusaSearchParametersStoreInterface } from '@lib/interfaces/searchParamaters.interface'
import { create } from 'zustand'

import { clearSearchParameters } from './actions/clearSearchParameters'
import { clearUserSearchParams } from './actions/clearUserSearchParams'
import { fetchSearchParameters } from './actions/fetchSearchParameters'
import { removeCurrentUserParam } from './actions/removeCurrentUserParam'
import { setCurrentUserParam } from './actions/setCurrentUserParam'

export const useMedusaSearchParametersStore =
  create<MedusaSearchParametersStoreInterface>((set, get) => ({
    isLoadingSearchParameters: false,
    error: null,
    searchParameters: {},
    searchDateRange: { startDate: null, endDate: null },
    selectedLocation: null,

    setSelectedLocation: (location) => set({ selectedLocation: location }),
    setSearchDateRange: (startDate, endDate) =>
      set({ searchDateRange: { startDate, endDate } }),
    clearSearchDateRange: () =>
      set({ searchDateRange: { startDate: null, endDate: null } }),

    fetchSearchParameters: async (locale) =>
      await fetchSearchParameters(locale, set),
    removeCurrentUserSearchParameter: (key) =>
      removeCurrentUserParam(key, get, set),
    clearSearchParameters: () => clearSearchParameters(set),
    currentUserSearchParameters: [],
    clearCurrentUserSearchParameters: () => clearUserSearchParams(get, set),
    setCurrentUserSearchParameter: (parameter, value, selected) =>
      setCurrentUserParam(parameter, value, selected, get, set),
  }))
